import API from 'services/api';

export const getContractCancellationExpenses = () => API.get('/api/cancellation-expenses');
